import React from 'react';
import PropTypes from 'prop-types';
import { Grid, IconButton, makeStyles } from '@material-ui/core';
import { NavigateBefore, NavigateNext } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  scrollButton: {
    '&[aria-disabled=true]': {
      visibility: 'hidden'
    }
  }
}));

const NavigationButton = ({ onClick, disabled, type }) => {
  const styles = useStyles();

  return (
    <Grid item>
      <IconButton
        className={styles.scrollButton}
        onClick={onClick}
        aria-disabled={disabled}
      >
        {type === 'next'
          ? <NavigateNext />
          : <NavigateBefore />
        }
      </IconButton>
    </Grid>
  );
};

NavigationButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  type: PropTypes.string
};

export default NavigationButton;
